import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Select } from "antd";
import LicenseOrders from "./license-orders";
import LicenseTariffs from "./license-tariffs";
import LicenseFilter from "./license-filter";
import "./license.css";
import { isMobile } from "@/extensions/design";
import { useState } from "react";

const License = ({ page }) => {
  const user = useSelector((s) => s.user);
  const navigate = useNavigate();
  const [showFilter, setShowFilter] = useState(false);
  const [filter, setFilter] = useState();

  const pages = [
    { title: "Покупки", link: "orders" },
    ...(user.isSuperadmin ? [{ title: "Тарифы", link: "tariffs" }] : []),
  ];

  const handlePageChange = (newPage) => {
    setShowFilter(false);
    navigate(`/license/${newPage}`);
  };

  const getPage = () => {
    switch (page) {
      case "orders": return <LicenseOrders externalFilter={filter}/>;
      case "tariffs": return user.isSuperadmin ? <LicenseTariffs /> : null;
      default: return <LicenseOrders />;
    }
  };

  const getItem = (title, link) => (
    <a 
      className={"col-one-title-item" + (link === page ? " col-one-title-selected " : "")} 
      href={`/license/${link}`}
    >
      {title}
    </a>
  );

  return !isMobile ? (
    <div className="col-one-main">
      <div className="col-one-title">
        {getItem("Покупки", "orders")}
        {user.isSuperadmin && getItem("Тарифы", "tariffs")}
      </div>
      <div className="col-one-col">{getPage()}</div>
    </div>
  ) : (
    <div className="sport-form-content">
      <div className="col-one-main">
        <div className="col-one-col">
          <div style={{ fontWeight: 600, fontSize: 16, margin: 8 }}>Лицензии</div>
          <div className='selector-filer-section'>
            <Select value={page} onChange={handlePageChange} style={{width: "100%"}}>
              {pages.map(p => (
                <Select.Option key={p.link} value={p.link}>
                  {p.title}
                </Select.Option>
              ))}
            </Select>
            {page === "orders" && (
              <>
                <img src="/images/filter.svg" className="mobile-top-img" alt="filter" onClick={() => setShowFilter(true)}/>
                {showFilter && <LicenseFilter value={filter} onClose={(filters) => { setShowFilter(false); if (filters) setFilter(filters); }}/>}
              </>
            )}
          </div>
          {getPage()}
        </div>
      </div>
    </div>
  );
};

export default License;

